'use client';
import React, { useEffect, useRef, useState } from 'react';

function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setInView(true);},
      { threshold }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, [threshold]);
  return { ref, inView };
}

const contactInfoItems = [
{
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_14493a884-1785328107810.png",
  text: 'Ananeraie, Yopougon, Abidjan, Côte d\'Ivoire',
  alt: 'Icône localisation',
  delay: '0.2s'
},
{
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_15251ea77-1766573989089.png",
  text: '+(225) 27 22 00 00 00',
  alt: 'Icône téléphone',
  delay: '0.4s'
},
{
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_1175352d5-1767644430280.png",
  text: 'contact@cosa-sante.ci',
  alt: 'Icône email',
  delay: '0.6s'
},
{
  icon: "https://img.rocket.new/generatedImages/rocket_gen_img_1913fd0d0-1768881194163.png",
  text: 'Lun au Sam 8h00 à 20h00',
  alt: 'Icône horaires',
  delay: '0.8s'
}];


export default function ContactNow() {
  const { ref, inView } = useInView();

  return (
    <div className="contact-now">
      <div className="dentaire-container">
        <div className="row align-items-center" ref={ref}>
          {/* Google Map */}
          <div className="col-lg-6">
            <div className="contact-google-map">
              <div className="google-map-iframe">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3972.0!2d-4.0833!3d5.3364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfc1ea7b0b0b0b0b%3A0x0!2sYopougon%2C%20Abidjan%2C%20C%C3%B4te%20d'Ivoire!5e0!3m2!1sfr!2sci!4v1703158537552!5m2!1sfr!2sci"
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="COSA Centre Médical Ananeraie Yopougon">
                </iframe>
              </div>
            </div>
          </div>

          {/* Contact Content */}
          <div className="col-lg-6">
            <div className="contact-now-content">
              <div className="section-title">
                <h3
                  style={{
                    opacity: inView ? 1 : 0,
                    transform: inView ? 'translateY(0)' : 'translateY(20px)',
                    transition: 'opacity 0.6s ease, transform 0.6s ease'
                  }}>
                  contactez-nous</h3>
                <h2
                  style={{
                    opacity: inView ? 1 : 0,
                    transform: inView ? 'translateY(0)' : 'translateY(20px)',
                    transition: 'opacity 0.6s ease 0.1s, transform 0.6s ease 0.1s'
                  }}>
                  
                  <span>Prenez Rendez-Vous</span> avec Nos Spécialistes
                </h2>
              </div>

              <div className="contact-now-info">
                {contactInfoItems?.map((item, i) =>
                <div
                  key={item?.text}
                  className="contact-info-list"
                  style={{
                    opacity: inView ? 1 : 0,
                    transform: inView ? 'translateY(0)' : 'translateY(20px)',
                    transition: `opacity 0.6s ease ${item?.delay}, transform 0.6s ease ${item?.delay}`
                  }}>
                  
                    <div className="icon-box">
                      <img src={item?.icon} alt={item?.alt} />
                    </div>
                    <div className="contact-info-content">
                      <p>{item?.text}</p>
                    </div>
                  </div>
                )}
              </div>

              <div
                className="contact-appointment-btn"
                style={{
                  opacity: inView ? 1 : 0,
                  transform: inView ? 'translateY(0)' : 'translateY(20px)',
                  transition: 'opacity 0.6s ease 1s, transform 0.6s ease 1s'
                }}>
                
                <a href="#" className="btn-default">prendre rendez-vous</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>);

}